import axios from '../config/axios';

/**
 * GET /userdatad/:id  (temporary prefix)
 * @param {Number} id
 * @param {String} token
 */
export async function fetchEntryById(id, token) {
  const { data } = await axios.get(`/userdatad/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return data; // { id, title, … }
}
